module.exports = {"TXTWCL_Bet_Builder":{"id":"TXTWCL_Bet_Builder","defaultMessage":"Byg væddemål"}}